import React from "react";
import { Box, Typography, Container, Paper, Grid, Avatar, Button } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import PublicIcon from "@mui/icons-material/Public";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

// --- Data for the page sections ---

const coreValues = [
    {
        icon: <PeopleIcon color="primary" sx={{ fontSize: 40 }} />,
        title: "Our Mission",
        desc: `To create a safe, engaging, and innovative platform where people from diverse backgrounds can connect, share ideas, and build meaningful communities without boundaries.`,
    },
    {
        icon: <PublicIcon color="primary" sx={{ fontSize: 40 }} />,
        title: "Our Vision",
        desc: `To become the most trusted and inclusive social platform worldwide, redefining digital interaction by blending simplicity with innovation for a global community.`,
    },
    {
        icon: <RocketLaunchIcon color="primary" sx={{ fontSize: 40 }} />,
        title: "Our Values",
        desc: `Transparency, inclusivity, and innovation form our foundation. We believe in building with honesty, respecting every user’s voice, and evolving to meet future needs.`,
    },
];

const teamMembers = [
    { name: "Alex Johnson", role: "Founder & CEO", img: 1 },
    { name: "Sophia Lee", role: "Head of Design", img: 2 },
    { name: "Michael Chen", role: "Chief Technology Officer", img: 3 },
    { name: "Emily Carter", role: "Head of Community", img: 4 },
    { name: "David Rodriguez", role: "Lead Data Scientist", img: 5 },
    { name: "Jessica Williams", role: "Marketing Director", img: 6 },
];

// --- The Main Component ---

const About = () => {
    return (
        <Box sx={{ backgroundColor: "#f4f6f8", py: { xs: 4, md: 8 } }}>
            <Container maxWidth="lg">

                {/* --- Hero Section --- */}
                <Box sx={{ textAlign: "center", mb: { xs: 6, md: 10 } }}>
                    <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: "bold", color: 'text.primary' }}>
                        About Vediverse
                    </Typography>
                    <Typography variant="h6" color="text.secondary">
                        Connecting People. Empowering Voices. Building Communities.
                    </Typography>
                </Box>

                {/* --- Mission, Vision, Values Section --- */}
                <Grid container spacing={4} sx={{ mb: { xs: 6, md: 10 } }}>
                    {coreValues.map((item) => (
                        <Grid item xs={12} md={4} key={item.title}>
                            <Paper
                                variant="outlined"
                                sx={{ p: 4, height: "100%", textAlign: "center" }}
                            >
                                <Box sx={{ mb: 2 }}>{item.icon}</Box>
                                <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                                    {item.title}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    {item.desc}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                {/* --- Our History Section --- */}
                <Paper sx={{ p: { xs: 3, md: 5 }, mb: { xs: 6, md: 10 } }} variant="outlined">
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 3 }}>
                        Our History
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                        Founded in 2020 with a simple yet powerful idea, Vediverse started as a small project aimed at creating a more positive and authentic online social space. We saw a need for a platform that prioritized user well-being and meaningful connections over algorithms designed solely for engagement.
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Through years of dedication, user feedback, and constant innovation, we have grown into a global community. Our journey has been fueled by a passion for technology and a deep-seated belief in the power of community to inspire change and foster growth.
                    </Typography>
                </Paper>

                {/* --- Team Section --- */}
                <Box sx={{ mb: { xs: 6, md: 10 } }}>
                    <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: "bold", mb: 5 }}>
                        Meet Our Team
                    </Typography>
                    <Grid container spacing={4} justifyContent="center">
                        {teamMembers.map((member) => (
                            <Grid item xs={12} sm={6} md={4} key={member.name}>
                                <Paper
                                    variant="outlined"
                                    sx={{ p: 3, textAlign: "center" }}
                                >
                                    <Avatar
                                        src={`https://i.pravatar.cc/150?img=${member.img}`}
                                        alt={member.name}
                                        sx={{ width: 100, height: 100, margin: "0 auto 16px" }}
                                    />
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                        {member.name}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {member.role}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
                
                {/* --- Join Us (CTA) Section --- */}
                <Box sx={{ textAlign: 'center', py: 4 }}>
                     <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                        Join Our Community
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ mb: 3, maxWidth: '600px', mx: 'auto' }}>
                        Ready to be a part of a growing community that values your voice? Join us today and start making meaningful connections.
                    </Typography>
                    <Button variant="contained" size="large" sx={{ px: 5, py: 1.5 }}>
                        Get Started
                    </Button>
                </Box>

            </Container>
        </Box>
    );
};

export default About;